import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export const PHASER_SLICE_KEY = 'phaser';

export interface PointerEventPayload {
  x: number;
  y: number;
}

export interface PhaserSliceState {
  sceneReady: string | null;
  lastPointerDown: PointerEventPayload | null;
  loadProgress: number;
  loadError: string | null;
}

const initialState: PhaserSliceState = {
  sceneReady: null,
  lastPointerDown: null,
  loadProgress: 0,
  loadError: null,
};

const phaserSlice = createSlice({
  name: PHASER_SLICE_KEY,
  initialState,
  reducers: {
    setSceneReady: (state, action: PayloadAction<string>) => {
      state.sceneReady = action.payload;
    },
    setPointerDown: (state, action: PayloadAction<PointerEventPayload>) => {
      state.lastPointerDown = action.payload;
    },
    setLoadProgress: (state, action: PayloadAction<number>) => {
      state.loadProgress = action.payload;
    },
    setLoadError: (state, action: PayloadAction<string>) => {
      state.loadError = action.payload;
    },
  },
});

const phaserReducer = phaserSlice.reducer as Reducer;
export default phaserReducer;
export const phaserActions = phaserSlice.actions;
export const phaserSelector = (state: RootState): PhaserSliceState =>
  state.phaser;
